<template>
    <div class="wrapper-landing">
      <LandingHero
        title="Erstelle deine kostenlose Multi-Shop-Wishlist"
        subtitle="Speichere und teile alles, was du dir wünschen kannst."
        origin="wishlist"
        listType="wishlist"
        buttonText="Erstelle deine Wishlist"
        lang="de-DE"
        logoStyle="white"
      >
        <template v-slot:cover>
          <source
            media="(max-width: 991px)"
            class=""
            srcset="../../assets/img/covers/cover-landing-wishlist-desk.jpg"
            alt=""
            loading="lazy"
          />
          <img
            class="ln-hero__inset"
            src="../../assets/img/covers/cover-landing-wishlist-desk.jpg"
            alt=""
            loading="lazy"
          />
        </template>
      </LandingHero>
      <main class="bg-cercles">
        <LandingAppRatings />
  
        <section class="bb-container">
          <LandingFeaturesSimple title="Du brauchst eine HelloBB-Liste, wenn:"
          :use-carousel="false"
          >
          <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
              </template>
              <template slot="title">
                Du dich gern organisierst und nichts vergessen möchtest
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
              </template>
              <template slot="title"> Du Dinge aus verschiedenen Shops wünschen willst </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
              </template>
              <template slot="title">
                Du eine einfache und sympathische Art suchst, deine Wünsche zu teilen
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
              </template>
              <template slot="title">
                Dein Umfeld ein wenig Hilfe braucht, um die richtigen Geschenke zu treffen
              </template>
            </LandingFeaturesSimpleItem>
          </LandingFeaturesSimple>
        </section>
      </main>
  
      <LandingFeaturesCover title="Eine Liste voller guter Dinge">
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-retailers-box-int.webp" alt="" />
          </template>
          <template slot="titulo">
            Wünsche dir jedes Modell, jede Marke, aus jedem Shop
          </template>
  
          <template slot="descripcion">
            <p>
                Kopiere jeden beliebigen Link und speichere ihn in deiner Liste. Volle Freiheit, genau das auszuwählen, was du willst.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
          </template>
          <template slot="titulo"> Erhalte Geld ohne Gebühren </template>
  
          <template slot="descripcion">
            <p>
                Deine Familie und Freunde können dir Dinge schenken oder dir Geld schicken, damit du sie selbst kaufst. Als Listeninhaber zahlst du nichts für den Erhalt von Geld.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <FeaturesCoverItemListUpdate lang="de-DE" />
      </LandingFeaturesCover>
  
      <main class="bg-cercles">
        <section class="bb-container">
          <LandingReviewsWedding lang="de-DE" />
        </section>
      </main>
  
      <LandingComoCols title="Wie funktioniert es?" subtitle="Deine Wunschliste ohne Grenzen">
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
          </template>
          <template slot="titulo">Wähle, was du willst</template>
          <template slot="descripcion">
            <p>
                Such dir einen Artikel aus einem beliebigen Onlineshop aus, kopiere den Link in HelloBB und speichere ihn.
            </p>
            <p>
              Du kannst auch eine Spardose anlegen, um Geld für alles zu sammeln, was du möchtest.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
          </template>
          <template slot="titulo">Teile deine Wünsche</template>
          <template slot="descripcion">
            <p>Wann immer du willst, teile deine Liste mit Familie und Freunden.</p>
            <p>
                Schicke ihnen einen Link, damit sie von überall und ohne Registrierung auf deine schön personalisierte Liste zugreifen können.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
          </template>
          <template slot="titulo">Erhalte deine Geschenke</template>
          <template slot="descripcion">
            <p>
                Deine Liebsten können sich ein Geschenk aus deiner Liste aussuchen und es kaufen.
Sie können es dir direkt zuschicken oder zu sich nach Hause liefern lassen, um es dir persönlich zu überreichen.
            </p>
            <p>
                Damit niemand dasselbe Geschenk doppelt kauft, können sie es in der Liste als verschenkt markieren.
            </p>
          </template>
        </LandingComoColsItem>
      </LandingComoCols>
  
      <LandingFooter lang="de-DE" />
    </div>
  </template>
  
  <script>
  import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";
  
  import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
  import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";
  
  import LandingHero from "./components/LandingHero.vue";
  import LandingAppRatings from "./components/LandingAppRatings.vue";
  import LandingFeaturesCover from "./components/LandingFeaturesCover";
  import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
  import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
  import LandingHablan from "./components/LandingHablan.vue";
  import LandingFooter from "./components/LandingFooter.vue";
  
  import LandingComoCards from "./components/LandingComoCards.vue";
  import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
  import LandingComoColsItem from "./components/LandingComoColsItem.vue";
  import LandingComoCols from "./components/LandingComoCols.vue";

  import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";
  
  // import bbButton from "../../components/buttons/bbButton.vue";
  
  export default {
    name: "LandingWeddingDE",
    metaInfo() {
      return {
        title: "HelloBB: deine Wunschliste ohne Grenzen",
        htmlAttrs: {
          lang: "de",
        },
        meta: [
          { name: "description", content: "HelloBB ist die Liste, in die wirklich all deine Wünsche passen." },
          { name: "robots", content: "noindex" },
        ],
      };
    },
    components: {
      LandingComoCols,
      LandingComoColsItem,
      LandingAppRatings,
      LandingHablan,
      LandingReviewsWedding,
      LandingFooter,
      LandingHero,
      LandingFeaturesCover,
      LandingFeaturesCoverItem,
      LandingFeaturesSlider,
      LandingFeaturesSimple,
      LandingFeaturesSimpleItem,
      LandingComoCards,
      LandingComoCardsItem,
      FeaturesCoverItemListUpdate,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
